import { Component, EventEmitter, OnInit, Output, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
    debounceTime,
    distinctUntilChanged,
    filter,
    map,
    Subject,
    switchMap
} from 'rxjs';
import { ComparatorRepository } from 'src-adisco/repositories/comparator.repository';
import { CommonService } from 'src-adisco/services/common.service';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { PATHS } from 'src/app/app-routing.module';

import { Category } from 'src-adisco/interfaces/categories';
import { FilterService } from 'src-adisco/services/filter.service';
import {
    buildCategoryHierarchy,
    buildCategoryHierarchyRandom,
    findMatchingNodes,
    getProductsInCategory,
    removeDuplicatesAndSort
} from 'src-adisco/utils/categories';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { environment } from 'src/environments/environment.adisco';
import { OGPATHS } from 'src-adisco/app-routing.module';

export class HeaderOption {
    ref?: string;
    title?: string; // matToolTip
    icon?: string; // mat-icon
    text?: string; // additional text
    route?: string;
    action?: CallableFunction;
}
export class NavOption {
    ref: string;
    title: string;
    route?: string;
    subMenu?: NavOption[];
    subMenuCategory?: boolean;
}

export enum Role {
    Partner = '[Extranet - Adhérent]',
    Commercial = '[Extranet - Commercial]',
    Supplier = '[Extranet - Fournisseur]',
    AdminGeolane = '[Administrateur Géolane]',
    AdminAdisco = '[Administrateur Adisco]',
    UserNoTarif = '[Extranet - Commercial sans tarif]'
}

@Component({
    selector: 'app-header-user',
    templateUrl: 'header-user.component.html',
    styleUrls: ['header-user.component.css'],
    providers: [MessageService, ConfirmationService],
})
export class HeaderUserComponent implements OnInit {
    searchForm: FormGroup;
    searchTerm = '';
    private searchTerm$ = new Subject<string>();
    autocompleteSearchList: any[] = [];
    @Output() result: EventEmitter<any> = new EventEmitter();
    roleUser = localStorage.getItem('role');
    codeUser = localStorage.getItem('surname');
    listProductCompare: any[] = JSON.parse(localStorage.getItem('compare') as any);
    checkedHomepage = true;
    checkShowheader = false;
    listCategories: any[] = [];
    listProduct: any[] = [];
    currentUrl: string;
    navOptions: NavOption[] = [];
    headerOptions: HeaderOption[] = [];
    categories: any[] = [];
    logoMember = '';
    comparatorItemList: any[] = [];
    get isMachinesActive(): boolean {
        return window.location.pathname.includes('/catalogues/:');
    }
    get isMachinesActive2(): boolean {
        return window.location.pathname.includes('/gestion');
    }
    hoveredNav?: string;
    isNavActive = false;
    userId = localStorage.getItem('userid');
    currentUser: any;
    comparatorCount: number = 0;
    formFilterProduct: FormGroup;
    allCategoriesById: any = {};
    listMemberCatalogSegmentation: any = [];
    supplierCode: string;
    allProductLinkToSupplier: any[] = [];
    cachedMemberInfo: any = null; // Cache for member info
    categoryList: any
    loading: boolean = false;
    frameModule: boolean = false;

    constructor(
        private renderer: Renderer2,
        public http: HttpclientService,
        private router: Router,
        private route: ActivatedRoute,
        private dynamicDocumentService: DynamicDocumentService,
        private _commonService: CommonService,
        public comparatorRepository: ComparatorRepository,
        public userService: UserService,
        private _fb: FormBuilder,
        private productService: ProductService,
        private profileCacheService: ProfileService,
        private filterService: FilterService
    ) {
        this.setSearchPipe();

        if (this.listProductCompare) {
            this.listProduct = this.listProductCompare;
            this.comparatorItemList = this.listProduct?.map((ele) => {
                return {
                    documentId: ele.id,
                    documentName: 'dynamic_product',
                    value: ele?.uniqueId,
                };
            });
        }

        this._commonService.getUpdateMyCatalog().subscribe((update) => {
            if (update) {
                this.getInfoProfile();
            }
        });
        // this._commonService.getClickProduct().subscribe((res) => {
        //   if (this.listProduct.length >= 5) {
        //     this._messageService.add({
        //       severity: 'error',
        //       summary: 'Error',
        //       detail: 'Maximum 5 products',
        //       life: 3000,
        //     });
        //     return;
        //   }
        //   if (this.listProduct.findIndex((e) => e === res) != -1) {
        //     this._messageService.add({
        //       severity: 'error',
        //       summary: 'Error',
        //       detail: 'The product already exists',
        //       life: 3000,
        //     });
        //     return;
        //   }
        //   this.listProduct.push(res);
        //   localStorage.setItem('listProduct', JSON.stringify(this.listProduct));
        // });
        // this._commonService.getClickCompareComplete().subscribe(() => {
        //   this.listProduct = [];
        // });
    }

    ngOnInit() {
        this.checkRouterShowHide();
        this.getInfoProfile();
        //this.getProductCatalog();
        this.fetchCategoriesHandleAllSystem();
        this.loadFrameMenu();
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any) => {
            this.isNavActive = false;
        });


        if (localStorage.getItem('surname')) {
            this.comparatorRepository.requestCountComparators().subscribe();
        }
        this.comparatorRepository.comparatorItemList$.subscribe((value) => {
            this.comparatorItemList = value;
            this.comparatorCount = this.comparatorItemList?.length;
            if (this.comparatorItemList?.length > 0) {
                const productIdSet = new Set();
                const comparatorIds: number[] = [];
                this.comparatorItemList.forEach((item: any) => {
                    if (!productIdSet.has(item?.value)) {
                        productIdSet.add(item?.value);
                        comparatorIds.push(item?.value);
                    }
                });

                if (comparatorIds.length > 0) {
                    this.getDetailProduct(comparatorIds);
                }
            }
        });
        this.formFilterProduct = this._fb.group({
            referenceProduct: [''],
        });
    }

    load() {
        if (!window.location.pathname.includes(PATHS.admin)) {
            this.fillNavOptions();
            this.fillHeaderOptions();

            if (window.location.pathname.includes(PATHS.catalogues)) {
                //this.loadAllProductLinkToSupplier(); // this call is not necessary since the dynamic legal entities have the link to articles
                //this.loadCategories();
            }
        }
    }

    loadFrameMenu() {
        if (window.location.href.includes(OGPATHS.import) || window.location.href.includes(OGPATHS.validation)) {
            this.frameModule = true;
            this.navOptions = [{ ref: 'import', title: 'Import de trames', route: `/${OGPATHS.import}` }];
            if ((this.roleUser === Role.AdminAdisco) || (this.roleUser === Role.AdminGeolane)) {
                this.navOptions.push({ ref: 'validate', title: 'Validation des trames', route: `/${OGPATHS.validation}` });
            }
        }
    }

    removeDuplicateProducts(uniqueIds: any[]) {
        const ids = uniqueIds.map((el) => el.uniqueId);
        this.listProduct = this.listProduct.filter((product) => !ids.includes(product?.uniqueId));
    }

    getDetailProduct(ids: number[]) {
        const condition = ids?.map((el) => ({
            type: 'EQUALS',
            value: el,
        }));

        let filters = [
            {
                fieldName: 'uniqueId',
                conditions: condition,
            },
        ];
        this.dynamicDocumentService
            .find(
                {
                    collectionName: 'dynamic_product',
                    filters: filters,
                    sorts: {
                        publishedOrder: 'DESC',
                    },
                    page: 1,
                    pageSize: 150,
                },
                true
            )
            .subscribe({
                next: (res) => {
                    this.removeDuplicateProducts(res?.content);
                    this.listProduct = res?.content;
                    localStorage.setItem('compare', JSON.stringify(this.listProduct));

                    /* const imageRequests = this.listProduct?.map((product) =>
                        product?.supplierItemNumber
                            ? product?.thumbnailPhoto?.[0]?.url
                            : of('src-adisco/assets/images/image-default.jpeg')
                    ); */
                    // forkJoin([...imageRequests]).subscribe(results => {
                    //   this.listProduct = this.listProduct.map((product, index) => ({
                    //     ...product,
                    //     urlImage: results[index],
                    //   }));

                    // })
                },
                error: (error) => { },
            });
    }

    // getListImage(supplierItemNumber: any): Observable<string> {
    //   return this.dynamicDocumentService.find({
    //     collectionName: 'dynamic_ressource',
    //     filters: [
    //       {
    //         fieldName: 'linkToProduct',
    //         conditions: [
    //           {
    //             type: 'EQUALS',
    //             value: supplierItemNumber,
    //             minValue: '',
    //             maxValue: ''
    //           }
    //         ]
    //       }
    //     ],
    //     sorts: {},
    //     page: 1,
    //     pageSize: 25
    //   }).pipe(
    //     map((res: any) => {
    //       const dataListImage = res.content;
    //       const firstMatchingItem = dataListImage.find((item: any) => {
    //         return item.typeOfResource?.value === 'PHOTO' && item.file?.length > 0;
    //       });
    //       return firstMatchingItem?.file[0]?.url || 'src-adisco/assets/images/image-default.jpeg';
    //     })
    //   );
    // }

    delProductToCompare(itemProduct?: any): void {
        if (!itemProduct?.id) return;
        this.comparatorItemList = this.comparatorItemList?.filter(
            (item) => item?.documentId !== itemProduct?.id
        );
        this.listProduct = this.listProduct.filter((item) => item?.id !== itemProduct?.id);
        this._commonService.sendClickCompare(this.comparatorItemList);
        this._commonService.sendClickDeleteCompareComplete(this.listProduct);
        this.comparatorRepository.deleteProduct([itemProduct?.id]);
        localStorage.setItem('compare', JSON.stringify(this.listProduct));
        this.formFilterProduct = this._fb.group({
            categoryProduct: [],
            fournisseur: [],
            referenceProduct: [],
            clpSafetyPicto: [null],
            foodContact: [null],
            biocide: [null],
            developpementDurable: [],
            countryOfManufacture: [],
            brand: [],
        });
    }

    checkRouterShowHide(): void {
        const access = localStorage.getItem('access');
        this.router.events.subscribe((event) => {
            if (
                (access && access.includes('admin')) ||
                (!access && window.location.pathname.includes(PATHS.login))
            ) {
                this.checkShowheader = false;
            } else if (access && !access.includes('admin')) {
                this.checkShowheader = true;
            }
            if (event instanceof NavigationEnd) {
                this.currentUrl = event.urlAfterRedirects;

                if (!this.currentUrl?.includes('/rechercher')) {
                    this.searchTerm = '';
                }

                if (this.currentUrl === '/accueil' || this.currentUrl === '/') {
                    this.searchTerm = '';
                    this.checkedHomepage = false;
                } else {
                    this.checkedHomepage = true;
                }
            }
        });
    }

    preventDefault(event: Event) {
        event.preventDefault();
    }

    openSubMenu(nav: NavOption) {
        this.hoveredNav = nav.subMenu ? nav.ref : undefined;
        this.addClassOverlay();
    }

    addClassOverlay(): void {
        const body = document.querySelector('body');
        this.renderer.addClass(body, 'overlay');
    }

    delClassOverlay(): void {
        const body = document.querySelector('body');
        this.renderer.removeClass(body, 'overlay');
    }

    fillHeaderOptions() {
        if (this.headerOptions.length == 0)
            this.http
                .get<NavOption[]>(`assets/mock-apis/extranet-header-${environment.client}.json`)
                .pipe(
                    map((head) => {
                        this.headerOptions = head;
                    })
                )
                .subscribe();
    }

    fillNavOptions() {
        if (!this.roleUser) return;
        if (this.navOptions.length == 0)
            this.userService.retriveUserRole().then((role) => {
                this.http
                    .get<{ partner: NavOption[]; supplier: NavOption[] }>(
                        `assets/mock-apis/extranet-menu-${environment.client}.json`
                    )
                    .pipe(
                        map(async (data) => {
                            let nav: NavOption[] = data.partner;

                            if (this.roleUser === Role.Partner) {
                                nav = data.partner;
                            }
                            if (this.roleUser === Role.Supplier) {
                                nav = data.supplier;
                            }

                            if (Array.isArray(this.userService.role?.extranetRestrictions?.menu)) {
                                this.navOptions = nav?.filter((n: NavOption) =>
                                    this.userService.role?.extranetRestrictions?.menu.includes(
                                        n.ref
                                    )
                                );
                            } else {
                                this.navOptions = nav;
                            }
                        })
                    )
                    .subscribe();
            });
    }
    loadCategories() {
        let filterCategories = [
            {
                fieldName: 'statusCategory',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'Publié',
                    },
                ],
            },
            // {
            //   fieldName: 'categoryLevelCategory',
            //   conditions: [
            //     {
            //       type: 'EQUALS',
            //       value: 1,
            //     },
            //   ],
            // },
            // {
            //   fieldName: "linkProduct",
            //   conditions: [
            //     {
            //       "type": "IS_NOT_EMPTY",
            //       "value": "",
            //     }
            //   ]
            // }
        ];

        this.dynamicDocumentService
            .getCategoryAllLevelStatusPublic([], 'linkToProduct')
            .subscribe((cats: any) => {
                const catalogTree = buildCategoryHierarchyRandom(cats.content);
                this._commonService.setTreeCategories(catalogTree);

                this._commonService.setFlatCategoriesByAllLevel(cats.content);

                let filterPublicProductIds: string[] = [];

                cats.content.forEach((category: any) => {
                    category?.linkProduct &&
                        Array.isArray(category.linkProduct) &&
                        category.linkProduct.forEach((product: any) => {
                            if (product?.documentId && product?.value) {
                                filterPublicProductIds.push(product.documentId);
                            }
                        });
                });
                const paginatedIds = filterPublicProductIds.slice(0, 1);
                this.dynamicDocumentService
                    .findByIds('dynamic_product', paginatedIds)
                    .pipe()
                    .subscribe((resProduct) => {
                        const publicCheckObj: any = {};

                        resProduct.forEach((product: any) => {
                            if (['Publié', 'Public'].includes(product.statusProduct?.value)) {
                                if (this.listMemberCatalogSegmentation.length) {
                                    product.nameSupplier?.some((sup: any) =>
                                        this.listMemberCatalogSegmentation.includes(sup.value)
                                    ) && (publicCheckObj[product.id] = true);
                                } else {
                                    publicCheckObj[product.id] = true;
                                }
                            }
                        });

                        // this.listCategories = cats.content.filter((cate: any) => cate.categoryLevelCategory === 1 && this.filterCateWithProduct(cate, publicCheckObj));
                        // this._commonService.setStoreFilteredCategories(this.listCategories);
                    });
            });
    }

    fetchCategoriesBySupplierName(codes: string[]) {
        this.dynamicDocumentService
            .getCategoryAllLevelStatusPublic(codes, 'linkProduct')
            .subscribe((res) => {
                const catalogTree = buildCategoryHierarchyRandom(res?.content);
                /* this.listCategories = getProductsInCategory(catalogTree); */
                this._commonService.setStoreFilteredCategories(this.listCategories);
                this._commonService.setStoreAllCategories(this.listCategories);
            });
    }

    filterCateWithProduct(category: any, publicCheckObj: any): boolean {
        if (
            category?.linkProduct &&
            category.linkProduct.length &&
            category.linkProduct.some((catePro: any) => publicCheckObj[catePro.documentId]) &&
            this.checkExistProductOfSupplierOnCategory(category.linkProduct, this.supplierCode)
        ) {
            return true;
        }

        if (category?.subcategories && category.subcategories.length) {
            for (const subCate of category.subcategories) {
                const findSubCate = this.allCategoriesById[subCate.documentId];

                if (
                    findSubCate?.linkProduct &&
                    findSubCate.linkProduct.length &&
                    findSubCate.linkProduct.some(
                        (catePro: any) => publicCheckObj[catePro.documentId]
                    ) &&
                    this.checkExistProductOfSupplierOnCategory(
                        findSubCate.linkProduct,
                        this.supplierCode
                    )
                ) {
                    return true;
                }

                if (
                    findSubCate?.subcategories &&
                    findSubCate.subcategories.length &&
                    findSubCate.categoryLevelCategory > category.categoryLevelCategory
                ) {
                    if (this.filterCateWithProduct(findSubCate, publicCheckObj)) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    setSearchPipe() {
        this.searchTerm$
            .pipe(
                debounceTime(300), // 300ms delay
                distinctUntilChanged()
            )
            .subscribe((searchTerm: string) => {
                if (searchTerm) {
                    this.autocomplete(searchTerm);
                } else {
                    this.autocompleteSearchList = [];
                }
            });
    }

    onSearchInput(): void {
        this.searchTerm$.next(this.searchTerm);
    }

    autocomplete(term: string) {
        this.autocompleteSearchList = [];
        if (term.length >= 3) {
            let filters = [
                {
                    fieldName: 'uniqueId',
                    operator: 'OR',
                    conditions: [{ type: 'EQUALS', value: term }],
                },
                {
                    fieldName: 'supplierItemNumber',
                    operator: 'OR',
                    conditions: [{ type: 'CONTAINS', value: term }],
                },
                {
                    fieldName: 'brand',
                    operator: 'OR',
                    conditions: [{ type: 'CONTAINS', value: term }],
                },
                {
                    fieldName: 'longDescription',
                    operator: 'OR',
                    conditions: [{ type: 'CONTAINS', value: term }],
                },
                {
                    fieldName: 'shortDescription',
                    operator: 'OR',
                    conditions: [{ type: 'CONTAINS', value: term }],
                },
                {
                    fieldName: 'statusProduct',
                    conditions: [{ type: 'EQUALS', value: 'Publié' }],
                },
                
            ];

            if (this.listMemberCatalogSegmentation.length) {
                filters.push({
                    fieldName: 'nameSupplier',
                    conditions: [
                        {
                            type: 'IN',
                            value: this.listMemberCatalogSegmentation as any,
                        },
                    ],
                });
            }
            
            if (this.roleUser == '[Extranet - Fournisseur]') {
                filters.push({
                    fieldName: 'nameSupplier',
                    conditions: [
                        {
                            type: 'EQUALS',
                            value: this.supplierCode,
                        },
                    ],
                });
            }

            this.productService
                .getProductListByIdAndNameAndSupplierNumberAndBrand(
                    {
                        collectionName: 'dynamic_product',
                        filters: filters,
                        sorts: {},
                        page: 1,
                        pageSize: 5,
                    },
                    true
                )
                .subscribe((res: any) => {
                    this.autocompleteSearchList = res.content;
                });
        }
    }

    emptyList() {
        setTimeout(() => {
            this.autocompleteSearchList = [];
        }, 300);
    }

    selectItem(item: any) {
        if (!item?.uniqueId) {
            return;
        }
        this.router.navigateByUrl(`/catalogues/product-detail/${item?.uniqueId}`);
    }

    submitSearch(): void {
        this.formFilterProduct.patchValue({
            referenceProduct: this.searchTerm,
            // brand: this.searchTerm,
            // uniqueId: this.searchTerm,
            // supplierItemNumber: this.searchTerm,
        });
        this._commonService.setFilterByKey('categories', null);
        this._commonService.sendClickEventSearch(this.formFilterProduct.value);
        this.router.navigate(['/catalogues/rechercher']);
    }

    compareProduct(): void {
        this._commonService.sendClickCompare(this.comparatorItemList);
        this.router.navigateByUrl('/product-comparator');
    }

    showNav(): void {
        this.isNavActive = true;
    }

    hideNav(): void {
        this.isNavActive = false;
    }

    getInfoProfile(): void {
        if (this.userId) {
            this.profileCacheService
                .getUserProfile(this.userId)
                .pipe(
                    switchMap((user) => {
                        this.currentUser = user;
                        const linkToLegalEntityId =
                            this.currentUser?.linkToLegalEntity?.documentId ?? '';
                        /* this.profileCacheService.getMemberInfo(linkToLegalEntityId); */
                        return this._commonService.getInfoMember(linkToLegalEntityId);
                    })
                )
                .subscribe({
                    next: (res) => {
                        this.applyMemberInfo(res);
                    },
                    error: (error) => {
                        console.error('Error fetching member info:', error);
                    },
                });
        }
    }

    // Helper method to apply member info to component properties
    applyMemberInfo(memberInfo: any): void {
        this.logoMember = memberInfo?.logo[0]?.url ?? '';
        this.listMemberCatalogSegmentation =
            memberInfo?.memberCatalogSegmentation?.map((seg: any) => seg?.value) ?? [];


            
        if (memberInfo?.code) {
            this.codeUser = memberInfo.code;
            if (this.roleUser === Role.Supplier) {
                this.supplierCode = this.codeUser ?? '';
            }
        }
        if (memberInfo?.linkToArticles) {
            this.allProductLinkToSupplier =
                memberInfo?.linkToArticles?.map((product: any) => product?.documentId) ?? [];
        }
        switch (this.roleUser) {
            case Role.Supplier:          
                this.getCategoriesBySuplier([this.currentUser?.linkToLegalEntity?.value]);
                this.getListSuppliers()
                break;

            default:
                if (this.listMemberCatalogSegmentation.length) {
                    this.getCategoriesBySuplier(this.listMemberCatalogSegmentation);
                    this.getListSuppliers()
                } else {
                    this.getProductCatalog();
                    this.getListSuppliers()
                }
                break;
                break;
        }

        // Call the load function (which can handle other logic)
        this.load();
    }

    checkExistProductOfSupplierOnCategory(linkProductArray: any[], idSupplier: string) {
        if (!idSupplier) return true;

        if (Array.isArray(linkProductArray) && this.allProductLinkToSupplier?.length > 0) {
            return (
                linkProductArray.filter((product) =>
                    this.allProductLinkToSupplier.includes(product?.documentId)
                ).length > 0
            );
        }

        return false;
    }

    // loadAllProductLinkToSupplier() {
    //   let filterProducts = [
    //     {
    //       fieldName: 'statusProduct',
    //       conditions: [
    //         {
    //           type: 'EQUALS',
    //           value: 'Publié',
    //         },
    //       ],
    //     },
    //     {
    //       fieldName: 'nameSupplier',
    //       conditions: [
    //         {
    //           type: 'EQUALS',
    //           value: this.supplierCode ?? '',
    //         },
    //       ],
    //     },
    //   ];

    //   this.dynamicDocumentService
    //     .find(
    //       {
    //         collectionName: 'dynamic_product',
    //         filters: filterProducts,
    //         sorts: {},
    //         page: 1,
    //         pageSize: 100000,
    //       },
    //       true
    //     )
    //     .subscribe((res: any) => {
    //       this.allProductLinkToSupplier = res?.content?.map((product: any) => product?.id) ?? [];
    //     });

    // }

    getProductCatalog() {
        this.loading = true;
        this.dynamicDocumentService.getCategoryRootLevelStatusPublic().subscribe({
            next: (res: Category[]) => {
                this.listCategories = res.sort(
                    (a, b) => parseInt(a?.codeCategory) - parseInt(b?.codeCategory)
                );
                this._commonService.setStoreFilteredCategories(this.listCategories);
                this._commonService.setStoreAllCategories(this.listCategories);
                this.loading = false;
            },
            error: (err) => {
                this.loading = false;
            },
        });
    }

    fetchCategoriesHandleAllSystem() {
        this.dynamicDocumentService
            .getCategoryAllLevelStatusPublic(
                this.listMemberCatalogSegmentation,
                'linkToProduct'
            )
            .subscribe({
                next: (res) => {
                    const result = res?.content;
                    this._commonService.setAllCategoriesHandleSystem(result);
                },
                error: () => {
                },
            });
    }

    onClickCategory(item: Category) {
        this.filterService.setIsClickNav(true);
        this.filterService.setFilters({});
        this.filterService.clearSessionStorage();
        this.router.navigate(['/catalogues', item.codeCategory]);
    }

    onRedirectNav(ref: string) {
        if (ref === 'fournisseurs') {
            this.filterService.clearFilters();
        }
    }

    getCategoriesBySuplier(suplier: string[]) {
        this.loading = true;        
        this.dynamicDocumentService
            .getCategoryAllLevelStatusPublic([], 'linkToProduct')
            .pipe(
                switchMap((result) => {
                    this.categoryList = result.content;
                    const filters = suplier
                        .map((el: string, index: number) => ({
                            fieldName: 'code',
                            operator: index > 0 ? 'OR' : undefined,
                            conditions: [
                                {
                                    type: 'EQUALS',
                                    value: el,
                                },
                            ],
                        }))
                        .map((filter) => {
                            if (filter.operator === undefined) {
                                delete filter.operator;
                            }
                            return filter;
                        });

                    return this.dynamicDocumentService
                        .find({
                            collectionName: 'dynamic_legal_entity',
                            filters: filters,
                            page: 1,
                            pageSize: suplier?.length,
                        })
                        .pipe(
                            map((item: any) => {
                                return item?.content.map((el: any) => el.linkToCategories);
                            })
                        );
                })
            )
            .subscribe({
                next: (res) => {
                    const ategories = res.flatMap((item: any) => item);
                    const dataTransfer = removeDuplicatesAndSort(ategories);

                    const findCategortList = findMatchingNodes(this.categoryList, dataTransfer);
                    const result = buildCategoryHierarchy(findCategortList);
                    this.listCategories = getProductsInCategory(result);
                    this._commonService.setStoreFilteredCategories(this.listCategories);
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                },
            });
    }

    getListSuppliers(): void {
        let filters = [
            {
                fieldName: 'typeOfLegalEntity',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'FOURNISSEUR',
                    },
                ],
            },
            {
                fieldName: 'status',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'Publié',
                    },
                ],
            },
        ];
        if (this.listMemberCatalogSegmentation.length) {
            filters.push({
                fieldName: "code",
                conditions: [
                    {
                        type: "IN",
                        value: this.listMemberCatalogSegmentation as any
                    }
                ]
            })
        };

        this.dynamicDocumentService
            .find({
                collectionName: 'dynamic_legal_entity',
                filters: filters,
                sorts: {
                    "companyName": "ASC"
                },
                page: 1,
                pageSize: 150,
            })
            .subscribe((res: any) => {
                this._commonService.setStoreFournissers(res.content);
            });
    };
}
